import { ApiClient, StationViewModel_, OnlineMenu, StationViewModel } from "@dining/api-client";
import { IApplicationInsights } from "@microsoft/applicationinsights-web";
import dayjs from "dayjs";
import { LoaderFunctionArgs } from "react-router-dom";

export type MenuListLoaderData = {
  station?: StationViewModel;
  menus: OnlineMenu[];
};

export const menuListLoader =
  (appInsights: IApplicationInsights, client: ApiClient, selectedDate: dayjs.Dayjs) =>
  async ({ params }: LoaderFunctionArgs): Promise<MenuListLoaderData> => {
    const { cafeId, stationId } = params;
    let stations: StationViewModel_ = {
      items: [],
      count: 0,
      init: () => {},
      toJSON: () => ({}),
    };
    try {
      stations = await client.getCafeStationsList(cafeId!);
    } catch (error) {
      appInsights.trackException(
        { exception: error as Error },
        {
          method: "getCafeStationsList",
          cafeId,
        },
      );
    }
    const station = stations.items?.find((s) => s.id === stationId);
    const menus = await client.getStationFullMenusForDayOfWeek(
      cafeId!,
      stationId!,
      dayjs(selectedDate).get("day"),
    );
    return { station, menus: menus.items! };
  };
